<!--
    描述：按钮
    时间：2021-04-09
    Created by zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>按钮列表</b></span>
                </div>
                <div class="btnGroups">
                    <el-button type="success"
                               size="small"
                               icon="el-icon-check"
                               v-if="roleBtns.includes('btn_permission_plus_save') && showBtn"
                               @click="saveClick()">保存</el-button>
                </div>
            </div>

            <div class="w-page-container pdb10">
                <div class="check-all" v-show="showCheckAll">
					<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
				</div>
                <div class="w-table-layout">
                    <div class="w-table-content"
                         ref="btnContent"
                         style=" overflow-y: auto; border:1px solid #eee">
                        <el-tree ref="btnTree"
                                 :height="tableObj.tableH"
                                 :data="tableObj.tableData"
                                 :props="defaultProps"
                                 :expand-on-click-node="false"
                                 :highlight-current="true"
                                 default-expand-all
                                 show-checkbox
                                 :check-strictly="true"
                                 node-key="id"
                                 @check="handleCheck"
                                 check-on-click-node
                                 :default-checked-keys="treeDefaultCheckedKey"></el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { getBtnsByRoleIdMenuId } from 'api/system/menuBtn.js'
import { saveOrUpdateRoleMenuBtn,getLimitMenuBtn } from 'api/system/role.js'
import { $deepCopy } from "utils/tools.js";
export default {
	components: {},
    props: {
        // 当前是 公共角色 还是 私有角色
        currentRole: {
            type: String,
            default: ''
        }
    },
	data() {
		return {
		    //传递对象
		    transObj: {
                roleId: '',
                menuId: '',
                menuName: '',
                mode: ''
            },

            btnLoading: false,
            //弹框对象
            dialogObj: {
                title: '',
                visible: false,
                width: '650px',
                mode: 'add'
            },
            tableObj: {
                loading: false,
                tableH: 400,
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                pageList: [10, 20, 50, 100] // 显示条数数组
            },
            defaultProps: {
                children: 'children',
                label: 'btnName'
            },
            //默认选择信息
            treeDefaultCheckedKey: [],
            //限制菜单按钮id信息
            limitMenuBtnIdList : [],
            // 全部按钮
            menuBtns: [],
            // 全选
            showCheckAll: false,
			checkAll: false,
			isIndeterminate: false,
		}
    },
    mounted() {
        // this.getMenuBtnTableList()
        this.$nextTick(() => {
            setTimeout(() => {
                this.tableObj.tableH = this.$refs.btnContent.offsetHeight
            }, 100)
        })
    },
    methods : {
        //初始化方法
        initMenuBtnInfo(obj) {
            //赋值菜单信息
            this.transObj = obj

            // 重置全选状态
            this.checkAll = false
            this.isIndeterminate = false
            //查询按钮信息
            //this.getMenuBtnTableList()
            //获取限制的菜单按钮信息 方法
            this.initData()
        },
        initData(){
            this.limitMenuBtnIdList = []
            //获取菜单按钮列表信息
            this.getLimitMenuBtns().then(val => {
                this.getMenuBtnTableList();
            });
        },
        //获取限制的菜单按钮信息
        getLimitMenuBtns(){
            let that = this
            return new Promise((resolve, reject) => {
                let param = {
                    id: this.transObj.roleId,
                    menuId: this.transObj.menuId
                }
                getLimitMenuBtn(param).then(res => {
                    if (res.operationCode == 1) {
                        this.limitMenuBtnIdList = res.data.concat()
                        resolve()
                    }
                })
            })
        },
        //获取菜单按钮列表信息
        getMenuBtnTableList() {
            let that = this
            let param = {
                roleId: this.transObj.roleId,
                menuId: this.transObj.menuId
            }

            that.treeDefaultCheckedKey = []
            that.menuBtns = []
            getBtnsByRoleIdMenuId(param).then(res => {
                if (res.operationCode == 1) {
                    let data = res.data.sysBtnList
                    this.menuBtns = res.data.sysBtnList.map(x => x.id)

                    // 是否展示全部
                    this.showCheckAll = res.data && res.data.sysBtnList.length > 0
                    if(res.data != null) {
                        that.treeDefaultCheckedKey = res.data.checkBtnIdList.concat()
                        
                        let _all = that.menuBtns.some(x => (that.treeDefaultCheckedKey.findIndex(y => y === x)) === -1)
                        that.checkAll = _all ? false : true
                        that.isIndeterminate = res.data.checkBtnIdList.length > 0 && _all
                    }
                    if(this.limitMenuBtnIdList.filter(id=> id== -1).length > 0) {
                        that.tableObj.tableData = data
                        return
                    }
                    that.tableObj.tableData = data.map(prop=>{
                        return {...prop, disabled : false}
                    })

                }
            })
        },
        // 确定按钮事件
        saveClick() {
            let that = this

            if (that.transObj.roleId == '') {
                that.$message({ message: '请选择角色信息', type: 'warning' })
                return
            }
            if (that.transObj.menuId == '') {
                that.$message({ message: '请选择菜单信息', type: 'warning' })
                return
            }
            let idsSelection = this.$refs.btnTree.getCheckedKeys().concat()
            let param = {
                roleId: that.transObj.roleId,
                menuId: that.transObj.menuId,
                btnIdsSelection: idsSelection
            }
            saveOrUpdateRoleMenuBtn(param).then(res => {
                if (res.operationCode == 1) {
                    that.$message({ message: '保存成功', type: 'success' })
                }
            })
        },

        // 树节点选择事件
        handleCheck(current, obj) {
            let _checkedAll = this.menuBtns.every(x => obj.checkedKeys.findIndex(y => y === x) > -1)
            this.checkAll = _checkedAll
            this.isIndeterminate = _checkedAll ? false : true

            if (obj.checkedKeys.length === 0) {
                this.isIndeterminate = false
            }
        },

        // 全选事件
		handleCheckAllChange(val) {
            let arr = $deepCopy(this.menuBtns, 'Array')
            this.isIndeterminate = false
            val ? this.$refs.btnTree.setCheckedKeys(arr, true) : this.$refs.btnTree.setCheckedKeys([], true)
		},
    },
    computed: {
        ...mapState('app', { clientSize: state => state.clientSize }),
        ...mapState('menu', {
            roleBtns: state => state.roleBtns
        }),

        ...mapState("user", {
            userInfo: (state) => state.userInfo,
        }),

        // 是否展示 btn
        showBtn() {
            let a = this.userInfo.roleType === 1
            let b = this.currentRole === '1003002'
            return a || b
        }
    },
    watch: {
        clientSize(val) {
            this.tableObj.tableH = this.$refs.btnContent.offsetHeight
        },
    },
}
</script>
<style lang="less" scoped>
.tree-content {
	overflow-y: auto;
	padding: 5px 0px;
}
.w-table-page {
	padding-bottom: 5px;
}
.w-page-container {
	display: flex;
	flex-direction: column;

	.check-all {
		height: 40px;
		line-height: 40px;
        border: 1px solid #eee;
        border-bottom: none;
        padding: 0 23px;
	}
}
</style>